import { render, staticRenderFns } from "./edu_liyou_author_sel.vue?vue&type=template&id=dd4f5fc8&scoped=true"
import script from "./edu_liyou_author_sel.vue?vue&type=script&lang=js"
export * from "./edu_liyou_author_sel.vue?vue&type=script&lang=js"
import style0 from "./edu_liyou_author_sel.vue?vue&type=style&index=0&id=dd4f5fc8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4f5fc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd4f5fc8')) {
      api.createRecord('dd4f5fc8', component.options)
    } else {
      api.reload('dd4f5fc8', component.options)
    }
    module.hot.accept("./edu_liyou_author_sel.vue?vue&type=template&id=dd4f5fc8&scoped=true", function () {
      api.rerender('dd4f5fc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/edu_liyou/edu_liyou_author_sel.vue"
export default component.exports